require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/set-immediate.js
// module id = hM5s
// module chunks = 0